import { FormLabel, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import {
  ContractFormFileUploadField,
  DropdownWithLabelsField,
  ContractdropdownField,
  CheckBoxField,
  FormDatepickerField,
  FormTextField,
} from 'shared/controls';
import { ContractRouteParams } from 'shared/types/routing';
import { useQueryCustomerBrandsByCustomer } from 'shared/queries';

export function ContractUploadFields() {
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const { customerBrands } = useQueryCustomerBrandsByCustomer(masterCustomer);
  const selectedBrands = watch('brands');
  const isNOTBrandOnly = watch('isBrandOnly') === false;

  return (
    <Grid container spacing={1}>
      <Grid xs={12} item>
        <FormTextField name={'billToCode'} label='Bill To Code' />
      </Grid>
      <Grid xs={12} item>
        <FormDatepickerField
          name='startDate'
          label='Contract Start Date'
          rules={{
            required: {
              message: 'Contract Start Date is required',
              value: true,
            },
          }}
          error={Boolean(errors.startDate)}
          helperText={errors.startDate?.message}
        />
      </Grid>
      <Grid xs={12} item>
        <FormDatepickerField
          name='endDate'
          label='Contract End Date'
          rules={{
            required: {
              message: 'Contract End Date is required',
              value: true,
            },
          }}
          error={Boolean(errors.endDate)}
          helperText={errors.endDate?.message}
        />
      </Grid>
      <Grid xs={12} item>
        <CheckBoxField name='isBrandOnly' label={`Contract is for ${abgBrand} only`} />
        {isNOTBrandOnly && (
          <DropdownWithLabelsField
            name='brands'
            defaultValues={[abgBrand]}
            options={customerBrands ?? ['']}
            label='Brands'
          />
        )}
      </Grid>
      <Grid xs={12} item>
        <ContractdropdownField
          name='copyInfofromContract'
          brands={isNOTBrandOnly ? selectedBrands : [abgBrand]}
          customer={masterCustomer}
        />
      </Grid>
      <Grid xs={12} item container>
        <Grid xs={12} item>
          <FormLabel>PDF Selection</FormLabel>
        </Grid>
        <Grid xs={12} item>
          <ContractFormFileUploadField
            name={'files'}
            accept={'application/pdf'}
            rules={{
              required: {
                message: 'PDF Selection is required.',
                value: true,
              },
            }}
            error={Boolean(errors?.files)}
            helperText={errors?.files?.message}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
